import { ShieldCheck } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../hooks/useStore';
import EditUserModal from './components/EditUserModal';
import DeleteUserDialog from './components/DeleteUserDialog';
import UsersTab from './tabs/UsersTab';
import styles from './UserManagement.module.css';

const UserManagement = () => {
  const { popupStore } = useStore();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.titleRow}>
            <span className={styles.titleIcon} aria-hidden="true">
              <ShieldCheck size={20} strokeWidth={2} />
            </span>
            <div className={styles.titleContent}>
              <h2 className={styles.mainTitle}>Kullanıcı Yönetimi</h2>
              <p className={styles.pageDescription}>
                Kullanıcı hesaplarını görüntüleyin, rollerini düzenleyin ve yönetin.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.gridContainer}>
          <UsersTab />
        </div>
      </div>

      <EditUserModal
        open={popupStore.isEditUserOpen}
        onClose={() => popupStore.setIsEditUserOpen(false)}
      />
      <DeleteUserDialog />
    </>
  );
};

export default observer(UserManagement);
